import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import { CREATE_GUEST_USER, CREATE_GUEST_USER_ERROR, CREATE_GUEST_USER_SUCCESS } from '../../actions';

function* createGuestUser({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/get-dashboard-data`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      yield put({
        type: CREATE_GUEST_USER_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: CREATE_GUEST_USER_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CREATE_GUEST_USER_ERROR, payload: error });
  }
}

export function* watchCreateGuestUser() {
  yield takeEvery(CREATE_GUEST_USER, createGuestUser);
}

function* createGuestUserSaga() {
  yield all([fork(watchCreateGuestUser)]);
}

export default createGuestUserSaga;
